


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { JobNotes } from '@/models/jobNotes/jobNotes';
import * as JobsAPI from '@/api/jobsApi';

@Component({})
export default class JobNotesDetail extends Vue {
  @Prop({ type: String, default: null }) public jobID!: string;
  @Prop({ type: Object, default: null }) public jobNotes!: JobNotes;
  @Prop({ type: Object, default: null }) public schedulerNote!: JobNotes;
  private loading: boolean = false;
  private errorMessage: string = null;

  goBack(){
    this.$router.go(-1);
  }

  get notes(){
    return this.jobNotes.notes;
  }

  onNotesChanged(v: string){
    this.jobNotes.notes = v;
  }

  async save(){
    this.loading = true;

    try {
      await JobsAPI.createOrUpdateNotes(this.jobID, this.notes);

      this.$emit('onDataChanged');
    } catch(err){
      this.errorMessage = err;
    }

    this.loading = false;

  }
}

